module.exports = __webpack_public_path__ + "static/img/zz-01.87317fce.jpg";